import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { DatePicker } from "antd";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
const isStatusOption = [
  { id: 1, label: "Active", value: true },
  { id: 0, label: "Inactive", value: false },
];

const VehicleExpenses = () => {
  const {
    watch,
    setValue,
    trigger,
    register,
    control,
    formState: { errors },
  } = useFormContext();

  console.log(watch());

  const index = 0;

  return (
    <>
      <div className="form-row row" key={index}>
        <h4 className="header-title">Vehicle Expenses</h4>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].vehicleNumber`}
            type="text"
            placeholder="Vehicle Number"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.vehicleNumber
                ? "is-invalid"
                : ""
            }`}
            label="Vehicle Number"
            labelClassName="form-label"
            required={true}
            requiredMessage="Vehicle Number is required"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].insuranceNumber`}
            type="text"
            placeholder="Insurance Number"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.insuranceNumber
                ? "is-invalid"
                : ""
            }`}
            label="Insurance Number"
            labelClassName="form-label"
            required={true}
            requiredMessage="Insurance Number is required"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].insuranceAmount`}
            type="number"
            placeholder="Insurance Amount"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.insuranceAmount
                ? "is-invalid"
                : ""
            }`}
            label="Insurance Amount"
            labelClassName="form-label"
            required={true}
            requiredMessage="Insurance Amount is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].insuranceVendor`}
            type="text"
            placeholder="Insurance Vendor"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.insuranceVendor
                ? "is-invalid"
                : ""
            }`}
            label="Insurance Vendor"
            labelClassName="form-label"
            required={true}
            requiredMessage="Insurance Vendor is required"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].company`}
            type="text"
            placeholder="Company"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.company
                ? "is-invalid"
                : ""
            }`}
            label="Company"
            labelClassName="form-label"
            required={true}
            requiredMessage="Company is required"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].insurancePeriod`}
            type="text"
            placeholder="insurancePeriod"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.insurancePeriod
                ? "is-invalid"
                : ""
            }`}
            label="Insurance Period"
            labelClassName="form-label"
            required={true}
            requiredMessage="Insurance Period is required"
            
          />
          {/* <div className="form-floating">
            <Controller
              name={`vehicleExpensesList[${index}].insurancePeriod`}
              control={control}
              render={({ field }) => (
                <RangePicker
                  {...field}
                  placeholder={["Insureance Start Date & End Date"]}
                  className={`form-control d-flex ${
                    errors?.vehicleExpensesList?.[
                      `${index}`
                    ]?.insurancePeriod
                      ? "is-invalid"
                      : ""
                  }`}
                  onChange={(date, dateFormat) => {
                    setValue(
                      "vehicleExpensesList[${index}].insurancePeriod",
                      `${dateFormat[0]} - ${dateFormat[1]}`
                    );
                  }}
                  // defaultValue={[
                  //   dayjs(watch("scheduleFromDate"), "YYYY-MM-DD"),
                  //   dayjs(watch("scheduleToDate"), "YYYY-MM-DD"),
                  // ]}
                  // getPopupContainer={(trigger) => trigger.parentNode}
                  // disabledDate={(current) => {
                  //   return current && current < dayjs().startOf("day");
                  // }}
                />
              )}
            />
            <label className="form-label">Insurance Period</label>
          </div> */}
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].insuranceAgency`}
            type="text"
            placeholder="Insurance Agency"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.insuranceAgency
                ? "is-invalid"
                : ""
            }`}
            label="Insurance Agency"
            labelClassName="form-label"
            required={true}
            requiredMessage="Insurance Agency is required"
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].insuranceExpiryDate`}
            type="date"
            placeholder="Insurance Expiry Date"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.insuranceExpiryDate
                ? "is-invalid"
                : ""
            }`}
            label="Insurance Expiry Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="Insurance Expiry Date is required"
            dateFormat="YYYY-MM-DD"
            
            // defaultValue={
            //   dayjs(watch("insuranceExpiryDate"), "YYYY-MM-DD") || null
            // }
          />
        </div>
      </div>
      <div className="form-row row" key={index}>
        <h4 className="header-title">Crane Insurance</h4>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].craneInsuranceExpiryDate`}
            type="date"
            placeholder="Crane Insurance Expiry Date"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.craneInsuranceExpiryDate
                ? "is-invalid"
                : ""
            }`}
            label="Crane Insurance Expiry Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="Crane Insurance Expiry Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={
            //   dayjs(watch("craneInsuranceExpiryDate"), "YYYY-MM-DD") || null
            // }
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].lorryCraneLMCertExpiryDate`}
            type="date"
            placeholder="Lorry Crane LM Cert Expiry Date"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.lorryCraneLMCertExpiryDate
                ? "is-invalid"
                : ""
            }`}
            label="Lorry Crane LM Cert Expiry Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="Lorry Crane LM Cert Expiry Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={
            //   dayjs(watch("lorryCraneLMCertExpiryDate"), "YYYY-MM-DD") || null
            // }
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].lgNextDueDate`}
            type="date"
            placeholder="LG Next Due Date"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.lgNextDueDate
                ? "is-invalid"
                : ""
            }`}
            label="LG Next Due Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="LG Next Due Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={dayjs(watch("lgNextDueDate"), "YYYY-MM-DD") || null}
          />
        </div>
      </div>
      <div className="form-row row" key={index}>
        <h4 className="header-title">Road Tax / Inspection</h4>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].roadTaxDueDate`}
            type="date"
            placeholder="Road Tax Due Date"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.roadTaxDueDate
                ? "is-invalid"
                : ""
            }`}
            label="Road Tax Due Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="Road Tax Due Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={dayjs(watch("roadTaxDueDate"), "YYYY-MM-DD") || null}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].inspectionDueDate`}
            type="date"
            placeholder="Inspection Due Date"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.inspectionDueDate
                ? "is-invalid"
                : ""
            }`}
            label="Inspection Due Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="Inspection Due Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={
            //   dayjs(watch("inspectionDueDate"), "YYYY-MM-DD") || null
            // }
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].roadTaxInspectionAmount`}
            type="number"
            placeholder="Road Tax Inspection Amount"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.roadTaxInspectionAmount
                ? "is-invalid"
                : ""
            }`}
            label="Road Tax Inspection Amount"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].roadTaxInvRef`}
            type="text"
            placeholder="Road Tax Invoice Reference"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.roadTaxInvRef
                ? "is-invalid"
                : ""
            }`}
            label="Road Tax Invoice Reference"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].ncd`}
            type="text"
            placeholder="No Claim Discount"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]?.ncd
                ? "is-invalid"
                : ""
            }`}
            label="No Claim Discount"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].remarks`}
            type="text"
            placeholder="Remarks"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.remarks
                ? "is-invalid"
                : ""
            }`}
            label="Remarks"
            labelClassName="form-label"
            
          />
        </div>
      </div>
      <div className="form-row row" key={index}>
        <h4 className="header-title">HDB Session Parking / VPC</h4>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].parkingNextDueDate`}
            type="date"
            placeholder="Next Parking Due Date"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.parkingNextDueDate
                ? "is-invalid"
                : ""
            }`}
            label="Next Parking Due Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="Next Parking Due Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={
            //   dayjs(watch("parkingNextDueDate"), "YYYY-MM-DD") || null
            // }
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].vpc`}
            type="text"
            placeholder="Vehicle Parking Card"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]?.vpc
                ? "is-invalid"
                : ""
            }`}
            label="Vehicle Parking Card"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].vpcAmount`}
            type="number"
            placeholder="VPC Amount"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.vpcAmount
                ? "is-invalid"
                : ""
            }`}
            label="VPC Amount"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].vpcAddress`}
            type="text"
            placeholder="VPC Address"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.vpcAddress
                ? "is-invalid"
                : ""
            }`}
            label="VPC Address"
            labelClassName="form-label"
            required={true}
            requiredMessage="VPC Address is required"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].parkingVendor`}
            type="text"
            placeholder="Parking Vendor"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.parkingVendor
                ? "is-invalid"
                : ""
            }`}
            label="Parking Vendor"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].parkingLocation`}
            type="text"
            placeholder="Parking Location"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.parkingLocation
                ? "is-invalid"
                : ""
            }`}
            label="Parking Location"
            labelClassName="form-label"
            required={true}
            requiredMessage="Parking Location is required"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].parkingAmount`}
            type="number"
            placeholder="Parking Amount"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.parkingAmount
                ? "is-invalid"
                : ""
            }`}
            label="Parking Amount"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].parkingCouponNextDueDate`}
            type="date"
            placeholder="Parking Coupon Next Due Date"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.parkingCouponNextDueDate
                ? "is-invalid"
                : ""
            }`}
            label="Parking Coupon Next Due Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="Parking Coupon Next Due Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={dayjs(watch("requireTill"), "YYYY-MM-DD") || null}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].parkingAddress`}
            type="text"
            placeholder="Parking Address"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.parkingAddress
                ? "is-invalid"
                : ""
            }`}
            label="Parking Address"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].parkingPaymentMode`}
            type="text"
            placeholder="Parking Payment Mode"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.parkingPaymentMode
                ? "is-invalid"
                : ""
            }`}
            label="Parking Payment Mode"
            labelClassName="form-label"
            
          />
        </div>
      </div>
      <div className="form-row row" key={index}>
        <h4 className="header-title">FMT Details</h4>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].fmtDueDate`}
            type="date"
            placeholder="FMT Due Date"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.fmtDueDate
                ? "is-invalid"
                : ""
            }`}
            label="FMT Due Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="FMT Due Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={dayjs(watch("fmtDueDate"), "YYYY-MM-DD") || null}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].fmtAmount`}
            type="number"
            placeholder="FMT Amount"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.fmtAmount
                ? "is-invalid"
                : ""
            }`}
            label="FMT Amount"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].shellCardNo`}
            type="text"
            placeholder="Shell Card Number"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.shellCardNo
                ? "is-invalid"
                : ""
            }`}
            label="Shell Card Number"
            labelClassName="form-label"
            
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].shellPIN`}
            type="text"
            placeholder="Shell Card PIN"
            className={`form-control ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.shellPIN
                ? "is-invalid"
                : ""
            }`}
            label="Shell Card PIN"
            labelClassName="form-label"
            
          />
        </div>

        {/* <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleExpensesList[${index}].isActive`}
            type="commonSelect"
            placeholder="Select Status"
            className={`form-control select ${
              errors?.vehicleExpensesList?.[`${index}`]
                ?.isActive
                ? "is-invalid"
                : ""
            }`}
            label="Status"
            labelClassName="form-label"
            optionData={isStatusOption}
            required={true}
            requiredMessage="Status is required"
            onChange={(selectedOption) => {
              setValue("isActive", selectedOption?.value);
              trigger("isActive");
            }}
            defaultValue={watch("isActive")}
          />
        </div> */}
      </div>
    </>
  );
};

export default React.memo(VehicleExpenses);
